import React, { useEffect, useState } from 'react';
import { effortGrades } from '../../utils';

const EffortLegend = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    () => document?.body?.classList.contains('dark') || false
  );

  useEffect(() => {
    const syncDarkMode = () => {
      setIsDarkMode(document.body.classList.contains('dark'));
    };

    syncDarkMode();

    const observer = new MutationObserver(syncDarkMode);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`flex flex-wrap items-center gap-2 rounded-xl border px-3 py-2 text-sm shadow-sm ${
        isDarkMode
          ? 'border-slate-700 bg-slate-900/90'
          : 'border-slate-200 bg-slate-50/90'
      }`}
    >
      {effortGrades.map(grade => (
        <div
          key={grade.label}
          className={`flex items-center gap-2 rounded-full border px-2 py-1 ${
            isDarkMode
              ? 'border-slate-700 bg-slate-950/60'
              : 'border-slate-200 bg-white'
          }`}
          title={`${grade.description} (Range: ${grade.effortMin} - ${grade.effortMax === Infinity ? '∞' : grade.effortMax})`}
        >
          <div
            className="h-4 w-4 rounded-md"
            style={{
              backgroundColor: isDarkMode ? grade.hexDark : grade.hex,
              border: `1px solid ${isDarkMode ? grade.borderColorDark : grade.borderColor}`
            }}
          />
          <span
            className="text-xs font-medium"
            style={{
              color: isDarkMode ? grade.textColorDark : grade.textColor
            }}
          >
            {grade.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default EffortLegend;
